import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "ofs pad20 w100 centered",
  style: {"margin-top":"80px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "fs14 skyblue fw600 mt10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MdProgressSpinner = _resolveComponent("MdProgressSpinner")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_MdProgressSpinner),
      _hoisted_2,
      (_ctx.loadingMessage)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.loadingMessage), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}